import angular from 'angular';

/**
 * @function camelCase
 * @memberof camelCase
 * @description
 * Transforms strings to camelCase strings
 * @param {string} input
 * @returns {string}
 */
const camelCase = input => input
	.replaceAll(/^\w|[A-Z]|\b\w/g, (letter, index) => (index === 0 ? letter.toLowerCase() : letter.toUpperCase()))
	.replaceAll(/(\s+|-)/g, '');

/* @ngInject */
/**
 * @returns {Function}
 */
function camelCaseFilter() {
	return (/** @type {string} */ input) => camelCase(input);
}

/**
 * @memberOf app
 * @ngdoc filter
 * @name app.filter:camelCase
 * @function
 * @description
 * # camelCase
 * Transforms strings to camelCase strings.
 *
 * @example
 *   Usage:
 *   <p>{{ STRING | camelCase }}</p>
 *
 *   <p>{{ 'Hello world' | camelCase }}</p> // returns <p>helloWorld</p>
 *
 */
angular.module('app')
	.filter('camelCase', camelCaseFilter);
